import {Map} from 'immutable'

import {
  SET_CURRENT_PAYOUT_REQUEST
} from '../action_types'

export default (state = Map({}), action) => {
  switch (action.type) {
    case SET_CURRENT_PAYOUT_REQUEST:
      if (action.payoutRequest) {
        return state
          .mergeDeep(action.payoutRequest)
          .merge({key: action.payoutRequestId})
      }
      else {
        return Map({})
      }

    default:
      return state
  }
}



/** WEBPACK FOOTER **
 ** ./modules/shared/data/reducers/current_payout_request.js
 **/